import React, { useEffect, useState } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import nl from 'video.js/dist/lang/nl.json'

interface Props {
  options?: any
  onReady: (player: any) => void
  subtitles: any
  setDuration: any
}

export const VideoJS: React.FC<Props> = ({ options, onReady, subtitles, setDuration }) => {
  const videoRef = React.useRef<any>(null)
  const playerRef = React.useRef<any>(null)
  const [useInterval, setUseInterval] = useState(true)
  const [video, setVideo]: any = useState()
  const [vidDuration, setVidDuration] = useState(0)

  videojs.addLanguage('nl', nl)

  const getDurationMinute = () => {
    if (useInterval) {
      const interval = setInterval(() => {
        if (video) {
          if (!Number.isNaN(video.duration())) {
            setVidDuration(video.duration())
            setUseInterval(false)
            clearInterval(interval)
          }
        }
      }, 200)
    }

    if (vidDuration > 0) {
      const seconds = Math.floor((vidDuration % 3600) % 60)
      const minutes = Math.floor((vidDuration % 3600) / 60)
      const mDisplay = minutes < 10 ? `0${minutes}` : minutes
      const sDisplay = seconds < 10 ? `0${seconds}` : seconds

      return `${mDisplay}:${sDisplay}`
    }

    return ''
  }

  const startVideo = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.keyCode === 13 || e.keyCode === 32) video.play()
  }

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js')

      videoElement.classList.add('vjs-big-play-centered')
      videoRef.current.appendChild(videoElement)

      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player)
      }))

      if (subtitles) {
        subtitles.forEach((subtitle: any) => {
          player.ready(() => {
            player.addRemoteTextTrack(
              {
                src: subtitle.src,
                label: subtitle.label,
                kind: 'subtitles',
                srclang: subtitle.srclang,
              },
              false,
            )
          })
        })
      }
    } else {
      const player = playerRef.current

      setVideo(player)

      player.autoplay(options.autoplay)
      player.src(options.sources)

      setDuration(getDurationMinute())
    }
  }, [options, videoRef])

  useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  return (
    <div onKeyDown={startVideo} data-vjs-player>
      <div ref={videoRef} />
    </div>
  )
}

export default VideoJS
